import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';

export type ProductFieldOverrides = {
    name?: string;
    categoryId?: number;
    lastPriceInCents?: number;
};

export type UpdateProductFieldsParams = {
    productId: number;
    overrides: ProductFieldOverrides;
};

const updateProductFields = async ({
    productId,
    overrides,
}: UpdateProductFieldsParams) => {
    const response = await api.patch(`/product/${productId}`, overrides);
    return response.data;
};

export const useUpdateProductFields = () => {
    return useMutation({
        mutationFn: updateProductFields,
    });
};
